<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-01 19:09:23
 * @Description: 风险管理
 -->

<template>
  <div class="risk-wrapper">
    <div class="img-wrapper" v-show="!showInformation">
      <div class="content">
        <img
          class="img-title"
          src="https://files.jinr.com/jinr-index/img/risk-title-01.png"
          alt=""
          srcset=""
        />
        <img
          class="img-content"
          src="https://files.jinr.com/jinr-index/img/risk-img-01.jpg"
          alt=""
          srcset=""
        />
      </div>
      <div class="content">
        <img
          class="img-title"
          src="https://files.jinr.com/jinr-index/img/risk-title-02.png"
          alt=""
          srcset=""
        />
        <img
          class="img-content"
          src="https://files.jinr.com/jinr-index/img/risk-img-02.png"
          alt=""
          srcset=""
        />
      </div>
      <div class="content">
        <img
          class="img-title"
          src="https://files.jinr.com/jinr-index/img/risk-title-03.png"
          alt=""
          srcset=""
        />
        <img
          class="img-content"
          src="https://files.jinr.com/jinr-index/img/risk-img-03.png"
          alt=""
          srcset=""
        />
      </div>
      <div class="content">
        <img
          class="img-title"
          src="https://files.jinr.com/jinr-index/img/risk-title-04.png"
          alt=""
          srcset=""
        />
        <img
          class="img-content"
          src="https://files.jinr.com/jinr-index/img/risk-img-04.png"
          alt=""
          srcset=""
        />
      </div>
      <div class="content">
        <img
          class="img-title"
          src="https://files.jinr.com/jinr-index/img/risk-title-05.png"
          alt=""
          srcset=""
        />
        <img
          class="img-content"
          src="https://files.jinr.com/jinr-index/img/risk-img-05.png"
          alt=""
          srcset=""
        />
      </div>
      <div class="content">
        <img
          class="img-title"
          src="https://files.jinr.com/jinr-index/img/risk-title-06.png"
          alt=""
          srcset=""
        />
        <img
          class="img-content"
          src="https://files.jinr.com/jinr-index/img/risk-img-06.png"
          alt=""
          srcset=""
        />
      </div>
      <div class="content">
        <img
          class="img-title"
          src="https://files.jinr.com/jinr-index/img/risk-title-07.png"
          alt=""
          srcset=""
        />
        <img
          class="img-content"
          src="https://files.jinr.com/jinr-index/img/risk-img-07.png"
          alt=""
          srcset=""
        />
      </div>
    </div>
    <risk-information class="text-wrapper" v-show="showInformation"></risk-information>
    <div class="footer">
      <div class="content btn-wrapper">
        <span @click="showInformation = true" v-show="!showInformation">风险管理信息 >></span>
        <span @click="showInformation = false" v-show="showInformation">返回 >></span>
      </div>
      <!-- <img src="https://files.jinr.com/jinr-index/img/sign.png" alt="" srcset="" /> -->
    </div>
  </div>
</template>
<script>
import RiskInformation from './risk-information';
export default {
  components: {
    RiskInformation
  },
  data() {
    return {
      showInformation: false
    };
  }
};
</script>
<style lang="less" scope>
.risk-wrapper {
  .content {
    padding: 20px 40px;
    img {
      display: block;
      margin: 0 auto;
    }
    .img-content {
      width: 100%;
    }
  }
  .btn-wrapper {
    text-align: right;
    span {
      display: inline-block;
      padding: 10px 20px;
      color: #247af1;
      cursor: pointer;
    }
  }
  .footer {
    text-align: right;
    img {
      width: 390px;
    }
  }
}
</style>
